/**
 * Utilitaires de formatage de dates (locale fr-BF).
 * Volontairement minimalistes : pas de dépendance externe.
 */

export function formatDueLabel(dueIso: string | null): string {
  if (!dueIso) return 'Sans échéance';
  const due = new Date(dueIso);
  const diffMs = due.getTime() - Date.now();
  const diffMin = Math.round(diffMs / 60000);
  if (diffMin < 0) return `En retard (${Math.abs(diffMin)} min)`;
  if (diffMin < 60) return `Dans ${diffMin} min`;
  const diffH = Math.round(diffMin / 60);
  if (diffH < 24) return `Dans ${diffH} h`;
  const diffD = Math.round(diffH / 24);
  return `Dans ${diffD} j`;
}

export type DueUrgency = 'late' | 'soon' | 'today' | 'later' | 'none';

export function getDueUrgency(dueIso: string | null): DueUrgency {
  if (!dueIso) return 'none';
  const diffMs = new Date(dueIso).getTime() - Date.now();
  if (diffMs < 0) return 'late';
  const diffH = diffMs / 3_600_000;
  if (diffH < 4) return 'soon';
  if (diffH < 24) return 'today';
  return 'later';
}

export function formatFrenchLongDate(date: Date = new Date()): string {
  try {
    return new Intl.DateTimeFormat('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  } catch {
    return date.toDateString();
  }
}

export function formatHourMinute(date: Date = new Date()): string {
  return new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
